import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';

const { challengeQuestionEndpoints } = environment;
@Injectable({
  providedIn: 'root',
})
export class ChallengeQuestionService {
  stateToken;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'Application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  requestSecretQuestion({ service, recoveryToken }) {
    const body = recoveryToken ? { recoveryToken } : { username: '' };
    const url = this.getRequestQuestionUrl(service);

    return this.http.post(url, body, this.httpOptions);
  }

  requestSecretAnswerVerification({ stateToken, answer, service }) {
    const body = { stateToken, answer };
    const url = this.getVerifyAnswerUrl(service);

    return this.http.post(url, body, this.httpOptions);
  }

  private getRequestQuestionUrl(service) {
    const endpoint = challengeQuestionEndpoints[service]?.endpoint;
    const path = challengeQuestionEndpoints[service]?.getQuestion;
    return `${environment.localSbxUrl}${endpoint}${path}`;
  }

  private getVerifyAnswerUrl(service) {
    const endpoint = challengeQuestionEndpoints[service].endpoint;
    const path = challengeQuestionEndpoints[service].verifyAnswer;
    return `${environment.localSbxUrl}${endpoint}${path}`;
  }
}
